import * as React from "react"
import Chip from "@mui/material/Chip"
import { Tooltip } from "@cirrus/ui-kit-ts/src/components/atoms/Tooltip"
import { AutocompleteChipsProps, AutocompleteItem } from "./types"

export const getRenderTags = (props: AutocompleteChipsProps) => {
  return (value: any, getTagProps: any) => value.map(({ id, title }: AutocompleteItem, index: number) => (
    <Tooltip key={id} title={title}>
      <Chip
        variant="outlined"
        label={title.trim().substr(0, 15)}
        size="small"
        {...getTagProps({ index })}
      />
    </Tooltip>
  ))
}
